import {MesswertMeteogroupRbb, MesswertMeteoGroupRbbMetaData} from './messwert-meteogroup-rbb';

export class Astrowetter extends MesswertMeteoGroupRbbMetaData{

  mondphase: Array<string>;
  werte: Array<Astrowerte>;
}

export class Astrowerte {
  datum: string;
  daemmerung: Astrowert;
  meridian: Astrowert;
  mondaufgang: Astrowert;
  monduntergang: Astrowert;
  sonnenuntergang: Astrowert;
  sonnenaufgang: Astrowert;
}

class Astrowert {
  einheit: string;
  wert: number;
}
